<template>
  <div>
    <div class="header" :class="{ transparent: transparent }">
      <div class="left">
        <!-- logo图 -->
        <div class="logo" @click="onHome">
          <img
            class="icon-earth"
            :src="
              transparent
                ? require('@/assets/svgs/logo.svg')
                : require('@/assets/svgs/logo-dark.svg')
            "
          />
        </div>
        <!-- 地址组件 -->
        <div class="address" v-if="showSearch">
          <CurAddress></CurAddress>
        </div>
        <!-- 搜索组件 -->
        <div class="search" v-if="showSearch">
          <ShopSearch></ShopSearch>
        </div>
      </div>
      <div class="right">
        <!-- 快捷入口 -->
        <p
          class="quick-func"
          v-for="(item, i) in showQuickEntrance ? quickList : []"
          :key="i"
          @click="action(item.tag, item)"
        >
          {{ item.content }}
        </p>
        <!-- 用户信息 -->
        <div
          v-if="!headUrl"
          class="user-wrapper"
          :class="{ 'user-wrapper-user': isUser }"
        >
          <i
            class="toggle-icon icon-outline_personalcenter"
            @click="showSidebar"
          ></i>
        </div>
        <img
          v-else
          class="header-logo"
          :src="headUrl"
          @click="showSidebar"
          v-http2
          v-img-size="'medium'"
          v-img-error
        />
        <div
          v-if="!isUser"
          class="login-btn"
          @click="onLogin(LOGIN_SOURCE_MAP.index_btn)"
        >
          {{ $t('登录') }}
        </div>
        <!-- 个人中心  -->
        <el-dropdown
          v-if="isUser"
          class="login-dropdown-link"
          trigger="click"
          :hide-on-click="true"
          @visible-change="dropdownChange"
        >
          <span class="dropdown-link">
            <span>HI，{{ userName }}</span>
            <i
              class="icon-outlinedpickup"
              :class="{ top: personalCenterShow }"
            ></i>
          </span>
          <Personal
            v-if="sidebar"
            slot="dropdown"
            :bannerMap="bannerMap"
            :sideList="selEntryList"
            @action="action"
            @signout="onLogout"
          />
        </el-dropdown>
      </div>
    </div>
    <div class="h5-search" v-if="showSearch">
      <ShopSearch></ShopSearch>
    </div>
    <Sidebar
      ref="sidebar"
      :phone="userName"
      :headUrl="headUrl"
      :bannerMap="bannerMap"
      :quickList="quickList"
      :sideList="selEntryListH5"
      @action="action"
      @signout="onLogout"
    />
    <InviteFriednsDialog v-model="inviteFriednsShow" />
    <PersonalPopup v-model="personalShow" />
    <ConfirmMsg
      v-model="showConfirmMsg"
      :title="$t('确认退出吗？')"
      @confirm="confirmFn"
      @cancel="cancelFn"
    />
    <!-- <UpdateUserInfo ref="updateUserInfo"></UpdateUserInfo> -->
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import Sidebar from '../Sidebar';
import CurAddress from '../CurAddress';
import ShopSearch from '../ShopSearch';
import Personal from './personal';
import InviteFriednsDialog from '@/components/InviteFriedns/dialog.vue';
import PersonalPopup from '@/components/Personal/personalPopup.vue';
import ConfirmMsg from '@/components/ConfirmMsg/index.vue';
import { getLocalStorage } from '@/utils/localStorage';
import { quickList, selEntryList, selEntryListH5 } from './config.js';
import { LOGIN_SOURCE_MAP, add_login_tag_logs_fun } from '@/const/logs';
import { payOptions } from '@/utils/payOptions';
import { getLocale } from '@/utils/locale';
import { getDeliveryUrl } from '@/utils/baseUtil';

export default {
  name: 'my-header',
  components: {
    Sidebar,
    Personal,
    CurAddress,
    ShopSearch,
    ConfirmMsg,
    InviteFriednsDialog,
    PersonalPopup,
  },
  data() {
    return {
      quickList,
      selEntryList,
      selEntryListH5,
      inviteFriednsShow: false,
      showConfirmMsg: false,
      personalShow: false,
      personalCenterShow: false,
      LOGIN_SOURCE_MAP,
      locale: getLocale(),
    };
  },
  props: {
    isSupportJump: {
      type: Boolean,
      default: true,
    },
    // 不请求
    noIO: {
      type: Boolean,
      default: false,
    },
    // 是否不带背景色, 并适配白色模式
    transparent: {
      type: Boolean,
      default: false,
    },
    // 是否展示地址定位和搜索栏
    showSearch: {
      type: Boolean,
      default: false,
    },
    // 是否展示快捷入口
    showQuickEntrance: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState('common', ['sidebar', 'isH5', 'sideMap', 'country']),
    // ...mapState({
    //   payOptions: ({ pay }) => pay.payOptions,
    // }),
    bannerMap() {
      const { sidebar } = this;
      return sidebar ? sidebar.banner : null;
    },
    isUser() {
      return getLocalStorage('isLogin') || this.phone;
    },
    phone() {
      return this.sidebar?.selfInfo?.phone || '';
    },
    headUrl() {
      return this.sidebar?.selfInfo?.headUrl || '';
    },
    userName() {
      const firstName = this.sidebar?.selfInfo?.firstName || '';
      const lastName = this.sidebar?.selfInfo?.lastName || '';
      const phone = this.sidebar?.selfInfo?.phone || '';
      let name = '';
      if (firstName && lastName) {
        name = `${firstName}${lastName}`;
      } else {
        name = this.changePhone(phone);
      }
      return name;
    },
    query() {
      let query = this.$route?.query;
      delete query?.fromLogin;
      return query;
    },
  },
  watch: {
    isUser: {
      immediate: true,
      handler(val) {
        if (val && !this.noIO) {
          this.setIsLogin(true);
          this.getSidebar();
          this.getToken();
        }
      },
    },
  },
  mounted() {},
  methods: {
    ...mapActions('common', ['getSidebar', 'getToken']),
    ...mapMutations('common', ['setIsLogin', 'serIsPayCallback']),
    onHome() {
      if (!this.isSupportJump) return;
      if (this.$route.path === '/feed') {
        window.location.reload();
      } else {
        this.$router.push('/feed/');
      }
    },
    dropdownChange(show) {
      this.personalCenterShow = show;
      if (show) {
        this.$trackEvent({
          eventId: 'sailing_c_x_sidebar_common_sw',
          eventLabel: '侧边栏展示',
        });
      }
    },
    showSidebar() {
      if (this.isUser) {
        if (!this.isH5) return;
        this.$trackEvent({
          eventId: 'sailing_c_x_homepage_sidebar_entrance_ck',
          eventLabel: '侧边栏入口点击',
          attrs: {
            login_type: +this.isUser,
          },
        });
        this.$refs.sidebar.showSidebar();
      } else {
        this.onLogin();
      }
    },
    onLogin(type = LOGIN_SOURCE_MAP.sidebar) {
      add_login_tag_logs_fun(type);
      // this.$passport.login();
      this.$passportMonitor.login();
    },
    onLogout() {
      this.showConfirmMsg = true;
    },
    confirmFn() {
      this.showConfirmMsg = false;
      // this.$passport.logout(this.$route?.meta?.signOutNoBackFeed);
      this.$passportMonitor.logout();
      this.$trackEvent({
        eventId: 'sailing_c_x_sidebar_signout_ck',
        eventLabel: '退出登录点击',
      });
    },
    cancelFn() {
      this.showConfirmMsg = false;
    },
    action(type, item, isH5 = false) {
      if (!type) return;
      this.$trackEvent({
        eventId: 'sailing_c_x_sidebar_function_ck',
        eventLabel: '点击侧边栏里面的各个功能模块时触发',
        attrs: {
          button_type: type === 'profile' ? 'picture' : type,
        },
      });
      switch (type) {
        // 侧边栏 点击 pc H5 注意处理方式
        case 'profile':
          // 个人中心
          if (this.isH5) {
            this.$router.push({ path: '/user/profile/' });
            this.$refs.sidebar.closeSidebar();
          } else {
            this.personalShow = true;
          }
          break;
        case 'payment':
          // 钱包
          this.serIsPayCallback(false);
           import('@didi/ibt-cashier-js').then(module => {
            module.manage(payOptions(), () => {
              this.serIsPayCallback(true);
            })
          })
          break;
        case 'help':
          // Help
          this.$router.push({ path: '/user/help/' });
          break;
        case 'invite':
          // 邀请好友
          if (isH5) {
            this.$router.push({ path: '/user/invite/' });
            this.$refs.sidebar.closeSidebar();
          } else {
            this.inviteFriednsShow = true;
          }
          break;
        // 快捷入口
        case 'orders':
          // 订单
          if (!this.isUser) {
            this.onLogin(LOGIN_SOURCE_MAP.order);
            return;
          }
          this.$trackEvent({
            eventId: 'sailing_c_x_homepage_order_entrance_ck',
            eventLabel: '顶部导航中的订单入口点击',
          });
          this.$router.push({ path: '/order/' });
          break;
        case 'promotions':
          // 优惠券
          if (!this.isUser) {
            this.onLogin(LOGIN_SOURCE_MAP.coupons);
            return;
          }
          this.$trackEvent({
            eventId: 'sailing_c_x_homepage_coupons_entrance_ck',
            eventLabel: '顶部导航中的券入口点击',
          });
          this.$router.push({ path: '/user/coupon/' });
          break;
        case 'delivery':
          // 成为骑手
          {
            let url = getDeliveryUrl({
              locale: this.locale,
              country: this.country,
            });
            window.open(url, '_blank');
          }
          break;
        case 'favorite':
          // 我的收藏
          break;
        case 'banner':
          // banner
          this.$trackEvent({
            eventId: 'sailing_c_x_sidebar_banner_ck',
            eventLabel: '点击活动banner',
            attrs: {
              activity_id: item.activityId,
            },
          });
          item.url && window.open(item.url, '_blank');
          break;
      }
    },
    changePhone(value) {
      var len = value.length;
      var x = value.substring(4, len - 3);
      var values = value.replace(x, '****');
      return values;
    },
    // onSibar(tag) {
    //   if (tag === 'settings') {
    //     this.$refs.updateUserInfo.visible = true;
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
